import splitLocale from './split-locale';

// see https://de.wikipedia.org/wiki/ISO-3166-1-Kodierliste
const IMPERIAL_REGIONS = [
  'US', // USA
  'GB', // UK
  'UK', // also UK
  'BU', // Myanmar
  'LR' // Liberia
];

export function showMiles(locale) {
  const {region} = splitLocale(locale);

  if (!region) {
    return false;
  }

  return IMPERIAL_REGIONS.includes(region.toUpperCase());
}

export function kmToMiles(km) {
  return km * 0.6213712;
}

export function formatDistance(distanceInMeters, locale) {
  const distance = parseInt(distanceInMeters, 10);

  if (!distance || isNaN(distance)) {
    return '';
  }

  if (showMiles(locale)) {
    return `${Math.round(kmToMiles(distance / 1000) * 100) / 100} miles`;
  }

  if (distance >= 1000) {
    return `${Math.round((distance / 1000) * 100) / 100} km`;
  }

  return `${Math.round(distance)} m`;
}
